var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../app/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-69614e10\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../app/node_modules/vue-loader/lib/selector?type=styles&index=0!./productBind.vue")
}
var normalizeComponent = require("!../../../app/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../app/node_modules/vue-loader/lib/selector?type=script&index=0!./productBind.vue"
import __vue_script__ from "!!babel-loader!../../../app/node_modules/vue-loader/lib/selector?type=script&index=0!./productBind.vue"
/* template */
import __vue_template__ from "!!../../../app/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-69614e10\",\"hasScoped\":false,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../app/node_modules/vue-loader/lib/selector?type=template&index=0!./productBind.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/pages/productBind.vue"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-69614e10", Component.options)
  } else {
    hotAPI.reload("data-v-69614e10", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/productBind.vue
// module id = null
// module chunks = 